import React, { useState, useEffect } from 'react';
import { getIdpConfigs, createIdpConfig, deleteIdpConfig } from '../mocks/api';

export default function IdpConfigs() {
  const [configs, setConfigs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', type: 'source', provider: '', url: '', apiKey: '' });
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    const data = await getIdpConfigs();
    setConfigs(data);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    setSaving(true);
    await createIdpConfig(form);
    setForm({ name: '', type: 'source', provider: '', url: '', apiKey: '' });
    setShowForm(false);
    setSaving(false);
    load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this IdP configuration?')) return;
    await deleteIdpConfig(id);
    load();
  };

  const sourceConfigs = configs.filter(c => c.type === 'source');
  const destConfigs = configs.filter(c => c.type === 'destination');

  if (loading) return <div className="loading">Loading configurations...</div>;

  return (
    <div className="page">
      <div className="page-header">
        <h2>IdP Configurations</h2>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Cancel' : '+ New Configuration'}
        </button>
      </div>

      {showForm && (
        <div className="card form-card">
          <h3>Create New IdP Configuration</h3>
          <form onSubmit={handleCreate}>
            <div className="form-row">
              <div className="form-group">
                <label>Name</label>
                <input required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="e.g. Okta Production" />
              </div>
              <div className="form-group">
                <label>Type</label>
                <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}>
                  <option value="source">Source</option>
                  <option value="destination">Destination</option>
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Provider</label>
                <input required value={form.provider} onChange={e => setForm({ ...form, provider: e.target.value })} placeholder="e.g. Okta, Azure AD, Auth0" />
              </div>
              <div className="form-group">
                <label>URL</label>
                <input required type="url" value={form.url} onChange={e => setForm({ ...form, url: e.target.value })} placeholder="https://..." />
              </div>
            </div>
            <div className="form-group">
              <label>API Key</label>
              <input required type="password" value={form.apiKey} onChange={e => setForm({ ...form, apiKey: e.target.value })} placeholder="Enter API key" />
            </div>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Creating...' : 'Create Configuration'}
            </button>
          </form>
        </div>
      )}

      <div className="config-sections">
        <div className="card">
          <h3>Source IdPs</h3>
          {sourceConfigs.length === 0 ? (
            <p className="empty-state">No source IdPs configured yet.</p>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Provider</th>
                  <th>URL</th>
                  <th>Status</th>
                  <th>Created</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sourceConfigs.map(c => (
                  <tr key={c.id}>
                    <td><strong>{c.name}</strong></td>
                    <td>{c.provider}</td>
                    <td className="url-cell">{c.url}</td>
                    <td><span className={`badge badge-${c.status}`}>{c.status}</span></td>
                    <td>{c.createdAt}</td>
                    <td>
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(c.id)}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="card">
          <h3>Destination IdPs</h3>
          {destConfigs.length === 0 ? (
            <p className="empty-state">No destination IdPs configured yet.</p>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Provider</th>
                  <th>URL</th>
                  <th>Status</th>
                  <th>Created</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {destConfigs.map(c => (
                  <tr key={c.id}>
                    <td><strong>{c.name}</strong></td>
                    <td>{c.provider}</td>
                    <td className="url-cell">{c.url}</td>
                    <td><span className={`badge badge-${c.status}`}>{c.status}</span></td>
                    <td>{c.createdAt}</td>
                    <td>
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(c.id)}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
